import { css } from "@compiled/react";

import { Picture } from "@/components/wpl/image/src";

export const RovoDevAgentsLogo = () => {
    const cmsLogoStyle = css({
        height: "48px"
    });

    return (
        <Picture
            image={{
                src: `https://dam-cdn.atl.orangelogic.com/AssetLink/6o65b84k7gkin5q8y7g7tbf12116y058.svg`,
                alt: "Rovo Dev Agents Logo"
            }}
            css={cmsLogoStyle}
            key={"devai.ondemand"}
        />
    );
};
